import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import usePlausible from 'hooks/usePlausible'
import { useEffect, useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import subscribersApi from 'services/api/subscribers'

import styles from './EditGuestDialog.module.scss'

const EditGuestDialog = ({
  onClose,
  currentFirstName,
  currentLastName,
  currentEmail,
  chatId,
  refreshChat
}) => {
  const [isLoading, setIsLoading] = useState(false)

  const { addToast } = useToasts()

  const [firstName, setFirstName] = useState(currentFirstName)
  const [lastName, setLastName] = useState(currentLastName)
  const [email, setEmail] = useState(currentEmail)

  const { postEvent, plausibleEvents } = usePlausible()

  useEffect(() => {
    postEvent(plausibleEvents.ViewUpdateGuestDetailsDialog, {
      chatId
    })
  }, [postEvent, plausibleEvents, chatId])

  function handleChangeGuestDetails() {
    setIsLoading(true)

    postEvent(plausibleEvents.UpdateGuestDetail, {
      chatId
    })

    subscribersApi
      .update({
        byChatId: chatId,
        firstName,
        lastName,
        email
      })
      .then(() => {
        addToast('Guest details updated successfully', { appearance: 'success' })
        refreshChat()
        setIsLoading(false)
        onClose()
      })
      .catch(err => {
        addToast(`Something went wrong while updating guest details: ${err.toString()}`, {
          appearance: 'error',
          autoDismiss: true
        })
        setIsLoading(false)
        onClose()
      })
  }

  return (
    <ConfirmationDialog
      title="Update guest details"
      positiveMessage="Update"
      onConfirm={handleChangeGuestDetails}
      onPressEnter={handleChangeGuestDetails}
      onClose={onClose}
      isButtonDisabled={!(firstName.length > 1 && lastName.length > 1 && !isLoading)}
    >
      <div className={styles.nameInputs}>
        <TextInput
          label="First name"
          value={firstName}
          onChange={e => setFirstName(e.target.value)}
        />
        <TextInput
          label="Last name"
          value={lastName}
          onChange={e => setLastName(e.target.value)}
        />
      </div>
      <TextInput
        style={{ width: '340px' }}
        label="Email"
        value={email}
        onChange={e => setEmail(e.target.value)}
      />
    </ConfirmationDialog>
  )
}

export default EditGuestDialog
